import './Pulsating.css'

// @ts-ignore
export const Pulsating = ({ children }) => {

  return (
    <div className={"pulsating"}>
      {children}
    </div>
  )
}